import { EmailIntegrationService } from './../../_services/email-integration.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { GlobalService } from 'src/app/_services/global.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { EmailsettingsService } from 'src/app/_services/emailsettings.service';
import _ from 'underscore';
import { CandidateService } from 'src/app/_services/candidate.service';
import * as __ from 'lodash';
declare const clevertap;

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

@Component({
    selector: 'app-candidate-email',
    templateUrl: './candidate-email.component.html',
    styleUrls: ['./candidate-email.component.scss'],
    standalone: false
})
export class CandidateEmailComponent implements OnInit {

  placeholderlist = GlobalService.placeholderlist
  bulkemail_Form: UntypedFormGroup;
  customtempList: any;
  checboxvalue: any;
  range: any;
  sel: Selection;
  InputtoEdit: any;
  isTemplateEdited: boolean = false;
  placeid: boolean;
  incorrectdoc: boolean;
  special_char_error: boolean;
  uploadedFiles: Array<any> = [];
  selectedEmailTemplate: any = null;
  talentvalue: string = null;
  pipeline_list = GlobalService.PipelineStatus;
  candidate_emaillist: any[] = []
  bulkEmails:any[]=[]
  username : any = this._localstorageservice.getItem('ufname') + ' ' + this._localstorageservice.getItem('ulname')
  @Input() pipelinestatus:any;
  @Input() candidatenumber:any;
  @Input() emailforCandidate: any;
  @Input() BulkCandidateEmail: any[] = [];
  @Input() preSelectEmail: string = null;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @ViewChild('subject') subject: ElementRef;
  @ViewChild('successModal') successModal: TemplateRef<any>
  @ViewChild('noEmailModal') noEmailModal: TemplateRef<any>


  editorConfig: AngularEditorConfig = {

    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '5rem',
    placeholder: 'Please enter job description.',
    translate: 'no',
    uploadUrl: 'v1/images', // if needed
    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [[
      'fontSize',
      'insertVideo',
      'fontName',
      'heading',
      'customClasses'
    ]
    ]
  };
  talentErrorMessage: string;
  integratedemailsarray: any [] = [];
  useremailid: any //= "notification@webbtree.com"
  selectedItem: any = {};
  selectedPlatform: any = 'default';
  filesizeExceeded: boolean = false;
  candidatedetails: any[];
  candidate_withoutemail: any[];

  /** Candidates which unsubscribe from email */
  unsubscribedCandidateCount: number = 0;

  constructor(public modalService: NgbModal,
    private fb: UntypedFormBuilder, private _localstorageservice: LocalStorageService, private emailsettings: EmailsettingsService,
    public _candidateservice: CandidateService,private emailintegrationservice : EmailIntegrationService) { }

  ngOnInit() {
    if (this.emailforCandidate && this.emailforCandidate.contactdetails && this.emailforCandidate.contactdetails.emails) {
      let candidate_emaillist = this.emailforCandidate.contactdetails.emails.existingDetails ? this.emailforCandidate.contactdetails.emails.existingDetails : this.emailforCandidate.contactdetails.emails
      this.candidatenumber =  this.candidatenumber ? this.candidatenumber : this.emailforCandidate.basicdetails.candidatenumber
      this.pipelinestatus = this.pipelinestatus ?  this.pipelinestatus :this.emailforCandidate.basicdetails.pipelinestatus
      this.emailforCandidate.basicdetails = this.emailforCandidate.basicdetails[0] ? this.emailforCandidate.basicdetails[0] : this.emailforCandidate.basicdetails
      candidate_emaillist = _.uniq(candidate_emaillist, 'contactdetail')
      candidate_emaillist.forEach(element => {
      this.candidate_emaillist.push({
        email : element.contactdetail,
        todisplay : this.emailforCandidate.basicdetails.firstname + ' ' + this.emailforCandidate.basicdetails.lastname + ' <' + element.contactdetail + '>'
      })
      })
    }

    this.bulkemail_Form = this.fb.group({
      from: [this.useremailid, Validators.required],
      sentto: [null, Validators.required],
      todisplay: [null],
      selectedtemplateid: [null],
      subject: [null, Validators.required],
      emailtemplate: [null, Validators.required],
      fileupload: [],
      filename: [],
      fileurl: [],
      file: [],
    })

    let tempcandidatedetails = []
    this.BulkCandidateEmail.forEach(element => {
      if(element.basicdetails?.is_unsubscribed){
        this.unsubscribedCandidateCount ++;
      }
      else{
        if(element[0].contactdetails.emails && element[0].contactdetails.emails.length && !element[0].contactdetails.emails.existingDetails){
          element[0].contactdetails.emails.existingDetails = [element[0].contactdetails.emails[0]]
        }
        tempcandidatedetails.push({
          "name":  element[0].basicdetails.firstname +' ' + element[0].basicdetails.lastname, 
          "emailid" : element[0].contactdetails.emails && element[0].contactdetails.emails.existingDetails[0] ? element[0].contactdetails.emails.existingDetails[0].contactdetail : null,
          "checked" : element[0].contactdetails.emails && element[0].contactdetails.emails.existingDetails[0] ? true : false
        })
      }
    });

    this.bulkemail_Form.controls.emailtemplate.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      res = res ? res.replace(/<[^>]*>?/gm, '').toLowerCase() : ''
      if (res && (res.includes('onerror') || res.includes('prompt') || res.includes('src') || scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))) {
        this.bulkemail_Form.patchValue({
          emailtemplate: ""
        }, { emitEvent: false })
        this.bulkemail_Form.get('emailtemplate').setErrors({ 'scriptTagError': true })
      }else{
        this.bulkemail_Form.get('emailtemplate').setErrors(null)
      }
    })

    this.candidatedetails = tempcandidatedetails
    this.candidate_withoutemail = this.candidatedetails.filter(x => x.emailid == null)
    if (this.BulkCandidateEmail.length > 0) {
      this.bulkemail_Form.get('sentto').clearValidators();
      this.bulkemail_Form.get('sentto').updateValueAndValidity();
      this.bulkEmails.push(this.BulkCandidateEmail.map(x => {
        if(x[0].contactdetails.emails && x[0].contactdetails.emails.existingDetails[0]){
          return x[0].contactdetails.emails.existingDetails[0]
        }
      }))
      this.BulkCandidateEmail = this.bulkEmails[0].filter((x)=> {return x != undefined})
    }
    
    if(this.BulkCandidateEmail.length==0 && !this.emailforCandidate){
      this.modalService.dismissAll();
      this.passEntry.emit('noEmail')
    }
    this.getEmailTemplate()
    this.fetchIntegration()
  }

  ngAfterViewInit() {
    if(this.preSelectEmail) {
      const emailToPatch = this.candidate_emaillist.find(e => e.email === this.preSelectEmail)?.todisplay;
      this.selectcandidateemail({ target: { value: emailToPatch } });
      const element = document.querySelector('.wc-form-control.nobg.email-selection') as HTMLSelectElement;
      if(element) {
        element.value = emailToPatch
      }
    }
  }

   get totalCandidates(){
    return this.candidatedetails.length + this.unsubscribedCandidateCount;
   }

  testscript() {
    this.bulkemail_Form.controls.emailtemplate.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      if(res && (scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))){
        this.bulkemail_Form.get('emailtemplate').setErrors({ 'scriptTagError': true })
      }else{
        this.bulkemail_Form.get('emailtemplate').setErrors(null)
      }
    })
  }

  selectcandidateemail(e){
    this.bulkemail_Form.patchValue({
      sentto : this.candidate_emaillist.filter(x => x.todisplay == e.target.value)[0].email,
      todisplay :  this.candidate_emaillist.filter(x => x.todisplay == e.target.value)[0].todisplay,
    })
    this.bulkemail_Form.updateValueAndValidity()
  }

  addemailstosend(event,candidate){
    if(event.target.checked){
      this.BulkCandidateEmail.push({
        contactdetail : candidate.emailid
      })
    }else{
      this.BulkCandidateEmail = this.BulkCandidateEmail.filter(x => x.contactdetail != candidate.emailid)
    }
    this.BulkCandidateEmail = _.uniq(this.BulkCandidateEmail)
  }

  sortBY(data){
    return __.orderBy(data, [( o ) => { return o.emailid || ''}], ['asc']); 
  }

  collapseALldiv(){
      let elems = document.querySelectorAll(".collapse");
      elems.forEach.call(elems, function(el) {
          el.classList.remove("show");
      });
  }

  fetchIntegration(){
    this.emailintegrationservice.fetchintegratedemails().subscribe((res:any)=>{
     if(res.status == 'success'){
       if(res.integratedemailsarray && res.integratedemailsarray.length){
        this.integratedemailsarray = this.integratedemailsarray
        // console.log( this.integratedemailsarray , " this.integratedemailsarray")
        this.integratedemailsarray = this.integratedemailsarray.concat(res.integratedemailsarray).map((x:any)=>{
          let res = x
          if(x && x.integrationplatform == 'outlook'){
            x.icon = '../../../assets/ourtlook.png'
          }
          if(x && x.integrationplatform == 'gmail'){
            x.icon = '../../../assets/gmail.png'
          }
          return res
        })
        // .filter(x => x && x.integrationplatform != "outlook")
        if(this.integratedemailsarray &&  this.integratedemailsarray.length){
          let value = this.integratedemailsarray.filter(x => {return x.integrationplatform == 'gmail' || x.integrationplatform=='outlook'})[0].integrationplatform
          this.integratedemailsarray = this.integratedemailsarray.concat({
            emailid : this.useremailid,
            integrationplatform : this.selectedPlatform,
            icon : '../../../assets/group-8.png'
          })
          this.selectFromEmail(value)
        }
       }
     }
    })
  }

  getEmailTemplate() {
    this.emailsettings.getallEmailTemplate(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.customtempList = res.message
      }
      else {
        console.log("error")
      }
    })
  }

  selectFromEmail(e){
    this.selectedPlatform = e
    this.selectedItem['icon'] =this.integratedemailsarray.filter(x => x.integrationplatform == e)[0].icon
    this.selectedItem['emailid'] = this.integratedemailsarray.filter(x => x.integrationplatform == e)[0].emailid
  }

  selectedTemplateOption(event: any) {
    this.emailsettings.getEmailDetails(event.target.value,this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.selectedEmailTemplate = res.message[0];
        this.bulkemail_Form.patchValue({
          subject: this.selectedEmailTemplate.subject,
          emailtemplate: this.selectedEmailTemplate.template
        })
        this.isTemplateEdited = false;
      }
      else {
        console.log("Something went Wrong")
      }
    })
  }

  //Placeholder
  selectplaceholder(event: any) {
    this.checboxvalue = event.target.value;
    if (this.range) {
      if (this.InputtoEdit == 'body') {
        var el = document.createElement("div");
        el.innerHTML = ('<span class="nonEdit"> {{' + this.checboxvalue + '}} </span>');
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        this.range.insertNode(frag);
        // let text = document.getElementById('editor').innerHTML;
        // this.bulkemail_Form.patchValue({ emailtemplate: text })
        let elem = document.getElementsByClassName('ql-editor')[0];//This is the element that you want to move the caret to the end of
        this.setEndOfContenteditable(elem);
      } else if (this.InputtoEdit == 'subject') {
        var startPos = this.subject.nativeElement.selectionStart;
        this.subject.nativeElement.focus();
        this.subject.nativeElement.value = this.subject.nativeElement.value.substr(0, this.subject.nativeElement.selectionStart) + '{{' + this.checboxvalue + '}}' +
          this.subject.nativeElement.value.substr(this.subject.nativeElement.selectionStart, this.subject.nativeElement.value.length);
        this.subject.nativeElement.selectionStart = startPos;
        this.bulkemail_Form.patchValue({ subject: this.subject.nativeElement.value })
      }
    }
    this.checboxvalue = ''
    this.placeid = false
  }

  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
      range = document.createRange();//Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
      range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection();//get the selection object (allows you to change selection)
      selection.removeAllRanges();//remove any selections already made
      selection.addRange(range);//make the range you have just created the visible selection
    }
  }


  getCursorPosition(type) {
    this.InputtoEdit = type
    this.sel = window.getSelection();
    if (this.sel.getRangeAt && this.sel.rangeCount) {
      this.range = this.sel.getRangeAt(0);
      this.placeid = true
    }
  }

  uploadFile(event) {
    let resumeFile = event.target.files[0]
    this.incorrectdoc = false
    let requiredextncv = ['doc', 'docx', 'pdf', 'txt']
    var extension = resumeFile.name.split('.')[1];
    var format = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;
    var includeextn = requiredextncv.includes(extension.toLowerCase())
    if (!includeextn) {
      this.incorrectdoc = true
    }
    if(resumeFile.size > 5242880){
      this.filesizeExceeded = true
    }else{
      this.filesizeExceeded = false
    }
    if (format.test(resumeFile.name.split(".")[0])) {
      this.special_char_error = true
    } else {
      this.special_char_error = false
      if (resumeFile && this.incorrectdoc == false && this.filesizeExceeded == false) {
        this.emailsettings.uploadDocument(resumeFile).subscribe((data: any) => {
          if (data.status === 'success') {
            GlobalService.toBase64(resumeFile).then(file => {
              this.uploadedFiles.push({ filename: resumeFile.name, fileurl: data.url, file: file });
              this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
            }).catch(err => {
              this.uploadedFiles.push({ filename: resumeFile.name, fileurl: data.url, file: "" });
              this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
            });
          }
        })
      }
    }
  }

  replaceAll(str, term, replacement) {
    return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
  }

  removeFile(doc) {
    this.uploadedFiles = _.without(this.uploadedFiles, doc);
    this.bulkemail_Form.patchValue({ fileurl: _.pluck(this.uploadedFiles, 'fileurl'), filename: _.pluck(this.uploadedFiles, 'filename'), file: _.pluck(this.uploadedFiles, 'file') });
  }



  SendEmailToCandidate() {
    this.collapseALldiv()
    if (this.bulkemail_Form.valid && (this.BulkCandidateEmail.length > 0 || this.emailforCandidate)) {
      let formValue = this.bulkemail_Form.getRawValue();

      if (this.emailforCandidate) {
        this.BulkCandidateEmail.push({
          contactdetail : formValue.sentto
        })
      }
  
      let reqObj: any = {
        "candidateemails": this.BulkCandidateEmail.map(x => x.contactdetail),
        "from": formValue.from == 'notification@webbtree.com' ? this._localstorageservice.getItem('usermailid') : formValue.from,
        "subject": formValue.subject.replace(/'/g, "''"),
        "template": formValue.emailtemplate.replace(/'/g, "''"),
        "updatedby": this._localstorageservice.getItem('userid')
      }

      if(this.integratedemailsarray && this.integratedemailsarray.length){
        if(this.selectedPlatform == 'outlook' || this.selectedPlatform == 'gmail'){
          reqObj['integratedemailtype'] = this.selectedPlatform
        }
        reqObj['from'] = this.selectedItem['emailid']
      }
      if (formValue.fileurl && formValue.fileurl.length) {
        reqObj.attachments = formValue.fileurl.map((url, index) => {
          return {
            'filename': formValue.filename[index],
            'path': formValue.file[index]
          }
        });
      }

      this.emailsettings.sendbulkemail(reqObj).subscribe((res: any) => {
        if (res && res.status == "success") {
          if(this.emailforCandidate){
            this.modalService.dismissAll()
            const dialogRef = this.modalService.open(this.successModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
           }else{
            this.modalService.dismissAll()
            this.passEntry.emit('emailsend')
           }
           //- Clevertap Send email event
           let ctObj = {
             "No. of candidates": this.BulkCandidateEmail.length || 1,
             "Attachment": 'attachments' in reqObj ? reqObj.attachments.length : 0,
             "Sender": reqObj.from,
             "Email Template Name":reqObj.template
           }
           this.cleverTapEvent("SentEmail", ctObj);
        }else if(res.status == 'failure' && res.message == 'insufficient credits'){
          clevertap.event.push("Email_CreditExpiry");
          this.passEntry.emit('nocredits')
        }else if(res.status == 'failure' && res.message == 'mail limit exceeded'){
          this.passEntry.emit('limitexceeded')
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')
        }
      })
    } else {
      this.validateAllFormFields(this.bulkemail_Form);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  SaveTalent() {
    if (this.talentvalue != null) {
      let data = {
        "candidatenumber": this.candidatenumber,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "pipelinestatus": this.talentvalue,
        "activitylog": [
          {
            "action": "'update'",
            "tablename": "'candidate'",
            "type": "'pipeline status'",
            "updatedfieldname": "'pipelinestatus'",
            "oldvalue": "'" + this.pipelinestatus + "'",
            "newvalue": "'" + this.talentvalue + "'"
          }
        ]
      }
      this._candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          this._candidateservice.createCandidateData();
          this.passEntry.emit('emailsend')
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
}
